import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Img from "gatsby-image";
import { theme } from "../styles";
import styled from '@emotion/styled'
import { Wrapper } from '../components'
import website from '../../config/website'

import {
  CatalogItem,
  CatalogHeader,
} from '../components'
import {
  CatalogWrapper,
  ProductWrapper,
} from '../templates/catalogItemStyle'

const IndexWrapper = Wrapper.withComponent('main')
const Inner = styled.div`
  .gatsby-image-wrapper {
    max-width: 100% !important;
  }
  img {
    max-width: 100% !important;
    display: block;
  }
  p {
    margin: 1rem auto;
    font-family: "Lato" !important;
  }
  h2 {
    font-family: "Lato" !important;
    font-size: 2.4rem;
    margin: 0 0 0.5rem 0;
    font-weight: 500;
    color: #6d6d6d;
    text-transform: uppercase;
  }
  h3 {
    font-family: "Lato" !important;
    font-size: 1.4rem;
    margin: 0 0 2rem 0;
    font-weight: 300;
    color: #6d6d6d;
    text-transform: uppercase;
    span {
      font-weight: 500;
    }
    &.h2 {
      font-size: 1.8rem!important;
    }
  }
`;

const Head = styled.div`
  position: relative;
  margin-bottom: 1.35rem;
`;

const Hero = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-family: "Lato" !important;
    font-size: 1rem;
    line-height: 1.4rem;
    padding: 10rem 2rem 0 2rem;
    display: block;
  }
  h3.new {
    background:#fce477;
    color: #000;
    display: inline-block;
    border-radius: 5px;
    padding: 5px 10px;
    ${'' /* font-weight: bold; */}
    margin: 10px 0;
    font-size: 26px;
  }
  p.new {
    color: #283726;
    padding: 5px 0;
    margin: 0;
    a {
      font-weight: bold
    }
  }

  > div {
    width: 50%;
    &:first-of-type {
      padding-right: 1rem;
    }
    &:last-of-type {
      padding-left: 1rem;
    }
    p {
      margin-bottom: 1.35rem;
      font-size: 1.1rem;
      color: #6d6d6d;
    }
    .signature, .signature a {
      font-size: 16px;
    }
  }
  @media (max-width: ${theme.breakpoints.s}) {
    display: block;
    span {
      font-family: "Lato" !important;
      font-size: 1.2rem;
      line-height: 1.4rem;
      padding: 1rem 0;
      display: block;
    }
    > div {
      width: 100%;
      &:first-of-type {
        padding-right: 0;
      }
      &:last-of-type {
        padding-left: 0;
      }
      p {
        &:first-of-type {
          padding-top: 1.35rem;
        }
      }
    }
  }
`;

const JuilletMMXXV = ({ data }) => {

  const context = { slug: "exhibition", parent: "" };
  const artworks = data.artworks.nodes;
  
  return (
    <React.Fragment>
      <Helmet title={`Disch Rémy - La lettre`}>
        <link rel="stylesheet" type="text/css" href="https://unpkg.com/xzoom/dist/xzoom.css" media="all" />
        <script defer data-domain="dischr.com" src="https://plausible.io/js/script.js"></script>
      </Helmet>
      <CatalogHeader {...context} letter />
      <IndexWrapper id={website.skipNavId} style={{ paddingBottom: 0}}>
        <Inner>
          <Head>
            <Img
              fixed={data.banner.childImageSharp.fixed}
              placeholderStyle={{
                filter: "grayscale(100%) contrast(100%)",
                imageRendering: "pixelated",
                opacity: 0,
              }}
            />
            <Hero style={{ position: 'absolute', bottom: 0, left: '1rem' }}>
              <div style={{ width: '100%' }}>
                <h3 style={{ color: '#fff', opacity: .8 }}>
                  <small>Juillet 2025</small><br />
                </h3>
              </div>
            </Hero>
          </Head>
          <Hero>
            <div style={{ width: '100%', paddingTop: '2rem', paddingBottom: '2rem', paddingLeft: 0, paddingRight: 0 }}>
              <p>Bonjour,</p>
              
              <p>
                Voici une nouvelle lettre pour vous annoncer ma prochaine exposition personnelle, <strong><i>Mélancoria</i></strong>, qui se tiendra à la galerie Kurokami du <strong>lundi 8 au samedi 20 septembre 2025</strong>, dans le 5ᵉ arrondissement de Paris.
              </p>

              <p>
                <strong><i>Mélancoria</i></strong> rassemble les toiles peintes durant mon isolement de plus d’un an dans la forêt de Brocéliande.
                Ce retrait n’était pas une fuite, mais une nécessité : un retour au commencement, dans un lieu ancien, vibrant, où les légendes se confondent avec la mousse, la brume et le temps.
              </p>

              <p>
                Là-bas, j’ai pris le temps de me taire, de regarder, de peindre sans chercher à montrer.
              </p>

              <p>
                Il m’a fallu encore du temps pour rassembler ces toiles, les regarder vraiment, et accepter de les partager.
              </p>

              <p>
                Aujourd’hui, nous y sommes : l’exposition a pu voir le jour grâce à la rencontre avec la galerie japonaise <strong>Kurokami</strong>.
              </p>
              
              <p>
                En tant que collectionneur, je vous offre dès maintenant la possibilité d’accéder au catalogue de cette nouvelle exposition.
                Et si l’une des toiles vous touche particulièrement, vous pouvez dès à présent poser une option.
              </p>

              <p>
                Je serai heureux de répondre à vos questions si vous en avez.
              </p>

              <p>
                Quoi qu’il en soit, cette exposition sera avant tout un moment vivant et j’espère avoir la joie de vous y croiser.
                Durant l’été, je vous enverrai par mail l’invitation pour le vernissage ainsi que les dernières informations mises à jour.
              </p>

              <p>
                À Mélancoria, les toiles parlent en silence, au plaisir de vous y voir.
              </p>
              
              <p>
                Rémy
              </p>
              
            </div>
          </Hero>
        </Inner>
        {/* <hr /> */}
      </IndexWrapper>
      
      {/* <IndexWrapper id={website.skipNavId}>
        <Inner>
          <Hero>
            <div style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>

              <div>
                <h3 className="new">Nouveau</h3>
                <p className="new">
                  - Découvrez <a className="regular-link" href="https://shop.dischr.com/" target="_blank">ma nouvelle boutique en ligne "Portraits"</a>,
                  rassemblant une sélection d'huiles sur papier à un prix très abordable. Bénéficiez pour l'ouverture de cette boutique d'une réduction exceptionnelle de 35% pendant 48h sur toutes les oeuvres avec le code "<strong>LE CERCLE</strong>".
                </p>
                <p className="new">
                  - Rejoignez <a className="regular-link" href="https://www.patreon.com/remy_disch" target="_blank">ma page Patreon</a> et accédez aux coulisses de mon cheminement de création tout en soutenant mon travail à partir de 5€ par mois.
                </p>
              </div>
              
            </div>
          </Hero>
        </Inner>
      </IndexWrapper> */}

      <IndexWrapper id={website.skipNavId}>
        {/* <hr /> */}
        <Inner>
          <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
              <Hero>
                <a className="regular-link" href={data.og1.publicURL} target="_blank">
                  <img src={data.affiche.childImageSharp.fixed.srcWebp} alt={`Revue Ogzylone - Valérie Mégardon`} />
                </a>
                {/* <span>
                  <strong>Ogzylone</strong>, revue d'art contemporain<br />Valérie Mégardon - juillet 2024
                </span> */}
              </Hero>
          </div>
        </Inner>
        {/* <hr /> */}
      </IndexWrapper>
      
      <IndexWrapper id={website.skipNavId}>
        <Inner style={{ paddingTop: 0, paddingBottom: "3rem" }}>
          <Hero>
            <div style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
              <h3>MÉLANCORIA</h3>
              <p>
                En tant que collectionneur, je vous offre dès maintenant la possibilité d’accéder au catalogue de cette nouvelle exposition. Et si l’une des toiles vous touche particulièrement, vous pouvez dès à présent poser une option.
              </p>
            </div>
          </Hero>
          <Hero>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}>
              <a
                href="https://www.dischr.com/catalog/melancoria"
                target="_blank"
                style={{
                  border: '1px solid #b4cfb0',
                  background: '#b4cfb0',
                  color: '#f2f2f2',
                  fontWeight: 'bold',
                  display: 'block',
                  padding: '.5rem 1rem',
                  borderRadius: '5px',
                  width: '16rem',
                  margin: '0 .5rem',
                  textAlign: 'center'
                }}
              >
                Consulter le catalogue Mélancoria
              </a>

              <a
                href="mailto:dischr@gmail.com"
                style={{
                  fontSize: '14px',
                  textDecoration: 'underline',
                  display: 'block',
                  marginTop: '.5rem'
                }}
              >
                contact et informations
              </a>
            </div>
          </Hero>
        </Inner>
      </IndexWrapper>

      <ProductWrapper className={`banner picture`} 
        style={{ 
          backgroundImage: `url(${data.atelier.childImageSharp.fixed.srcWebp})`,
          backgroundPosition: 'center',
        }}
      />

      <IndexWrapper id={website.skipNavId}>
        <Inner>
          <Hero>
            <div style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
              <h3>Acquérir des oeuvres, soutenir mon travail</h3>

              <p>
                Si vous souhaitez acquérir et/ou vous informer de la disponibilité des oeuvres,
                je vous invite à me contacter directement en utilisant l'adresse email en pied de page.
              </p>
              
              <p>
                Vous pouvez également acquérir des oeuvres sur le site de mon partenaire <a className="regular-link" href="https://www.artsper.com/es/artistes-contemporains/france/102408/remy-disch" target="_blank">Artsper</a>
              </p>
              
              <p>
                ---
                <br /><h3 style={{ margin: 0, paddingBottom: "10px", paddingTop: "10px" }}>Rémy Disch</h3>
                <div className="signature">
                  Email : <a className="regular-link" href="mailto: davidbraud@dischr.com">dischr@gmail.com</a>
                  <br />Site internet : <a className="regular-link" href={`https://www.dischr.com`} target="_blank">www.dischr.com</a>
                  <br />Patreon : <a className="regular-link" href={`https://www.patreon.com/remy_disch`} target="_blank">patreon.com/remy_disch</a>
                </div>
              </p>
            </div>
          </Hero>
        </Inner>
      </IndexWrapper>
    </React.Fragment>
  );
};

export default JuilletMMXXV;

export const pageQuery = graphql`
  query JuilletMMXXV {
    banner: file(name: {eq: "bandeau_lettre_2025-07-06"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    affiche: file(name: {eq: "melancoria-affiche"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    atelier: file(name: {eq: "atelier"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    sub_banner: file(name: {eq: "Bandeau_revue"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    og1: file(name: {eq: "ogzylone-10-11-2024-full"}) {
      publicURL
      childImageSharp {
        fixed(width: 600, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    og2: file(name: {eq: "revue-02-c"}) {
      publicURL
      childImageSharp {
        fixed(width: 800, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    artworks: allPrismicArtwork(
        filter: {
            prismicId: {
                in: [
                    "ZVeLNhIAACwAK99S", 
                    "ZUeTtRUAACwA13_k", 
                ]
            }
        }, 
        sort: {
            order: DESC, 
            fields: first_publication_date
        }) {
      nodes {
        prismicId
        data {
          meta_description
          meta_title
          title {
            text
          }
          drouot_estimate
          catalog_fullscreen
          type
          available
          on_demand
          price
          item {
            alt
            localFile {
              childImageSharp {
                fixed(height: 800, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
                fluid(maxWidth: 800, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          cadre {
            alt
            localFile {
              childImageSharp {
                fixed(height: 800, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
                fluid(maxWidth: 800, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          image_hd {
            localFile {
              childImageSharp {
                original {
                  height
                  src
                  width
                }
              }
            }
          }
          categories {
            ... on PrismicArtworkDataCategories {
              category {
                uid,
                document {
                  data {
                    name
                  }
                }
              }
            }
          }
          year {
            ... on PrismicArtworkDataYear {
              uid
            }
          }
        }
      }
    }
  }
`
